export default "__VITE_ASSET__S1I7BnAy__"